<div>
  <div class="d-flex align-items-center gap-2">
    <img
      src="./assets/media/icons/generated-invoice.svg"
      alt="invoice"
      class="w-20px h-20px cursor-pointer"
      loading="lazy"
      *ngIf="!isLoad"
      [class.opacity-50]="isLoad"
      (click)="isLoad ? null : handleInvoice(row)"
    />
    <span class="spinner-border spinner-border-sm align-middle ms-2" *ngIf="isLoad"></span>
    <ng-container *ngFor="let item of paymentMethodList">
      <span
        *ngIf="
          row.paymentMethod === paymentMethod.NONE ||
            row.paymentMethod === item;
          else selected
        "
        (click)="
          togglePayService(
            row.patientRecordId,
            item,
            row.paymentMethod === paymentMethod.NONE
              ? 'not-selected'
              : 'selected'
          )
        "
        [class]="
          'badge cursor-pointer ' +
          (row.paymentMethod === item
            ? 'bg-success text-white'
            : 'bg-light text-dark')
        "
      >
        {{
          item === paymentMethod.PIN
            ? ("paidByPin" | translate)
            : ("paidByInvoice" | translate)
        }}
      </span>
      <ng-template #selected>
        <span class="badge bg-light text-dark d-none">
          {{
            item === paymentMethod.PIN
              ? ("paidByPin" | translate)
              : ("paidByInvoice" | translate)
          }}
        </span>
      </ng-template>
    </ng-container>
  </div>

  <!-- Invoice Modal -->
  <app-invoice-modal
    [id]="'invoiceModal-' + (row?.patientRecordId || '')"
    [patientRecordId]="patientRecordId"
    [invoiceReportGenerated]="invoiceReportGenerated"
    (downloadInvoiceEvent)="downloadInvoice()"
    (sendInvoiceEvent)="sendInvoice()"
    (closeModalEvent)="handleCloseModal()"
  ></app-invoice-modal>
</div>
